import React from 'react';
import Video from 'react-player'

export default function URLVideoPlayer(props) {

    return (
        <div>
            <div className='flex flex-col items-center justify-center lg:px-36'>
                <Video height="500px" width="100%" playing={true} loop={true}
                config={{youtube: {playerVars: {modestbranding: 0}}}}
                    url={props.video} />
            </div>
            {/* <div className='hidden md:flex flex-col items-center justify-center '>
                <Video height="100%" width="100%" url={props.video} />
            </div> */}
        </div>
    );
}